// extracted by mini-css-extract-plugin
export default {"controls":"style_controls__dxqEN"};